<template>
  <CampaignKpiBox
    :showCloseButton="isEditing"
    @closeKpiBox="$emit('removeKpi', kpiKey)"
  >
    <template slot="label">{{ label }}</template>
    <template slot="content">
      <span v-if="isLoading" class="no-kpis-message"><loading-icon /></span>
      <span v-else-if="!kpis.length" class="no-kpis-message">no data available</span>
      <div v-else class="kpi-details">
        <div class="progress-bar-container" v-for="kpi in kpis">
          <div class="progress-bar-info">
            <span class="truncate">{{ kpi.name }}</span>
            <span>{{ kpi.percent }}%</span>
          </div>
          <progress-bar :progress="kpi.percent/100" />
        </div>
      </div>
    </template>
  </CampaignKpiBox>
</template>

<script>
import {campaignAPI} from "../../services/api/campaignAPI";
// TODO: Import the progress bar from sb-components once available
import {ProgressBar, LoadingIcon} from "@springbig/sb-components";
import CampaignKpiBox from "./CampaignKpiBox";

export default {
  name: 'campaign-kpi-box-info',
  components: {
    ProgressBar,
    CampaignKpiBox,
    LoadingIcon
  },
  data() {
    return {
      label:'',
      kpis:null,
      isLoading:true,
    }
  },

  props: {
    kpiKey: '',
    selectedGroups: null,
    campaignId: null,
    dayOfWeek: null,
    isEditing: false
  },

  watch: {
    dayOfWeek: function() {
      this.updateKpi()
    },
    selectedGroups: function() {
      this.updateKpi()
    }
  },

  methods: {
    async updateKpi() {
      const result = await campaignAPI.getCampaignKpis(this.campaignId, this.kpiKey, this.dayOfWeek)
      this.label = result.data.label
      this.kpis = result.data.results.map(k=> ({...k, percent:k.total_count ? Math.round((k.count/k.total_count)*100) : 0}) )
      this.isLoading = false;
    }
  },

  created() {
    this.updateKpi()
  }
}
</script>

<style scoped>

  .kpi-details {
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: space-evenly;
    flex: 1;
  }

  .progress-bar-info{
    display: flex;
    justify-content: space-between;
    font-size:0.8em;
    line-height: 1em;
  }

</style>
